import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6daa524c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "positionBox"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "type1"
};
const _hoisted_4 = {
  class: "title2"
};
const _hoisted_5 = {
  class: "type"
};
const _hoisted_6 = {
  key: 0,
  style: {
    "display": "flex",
    "flex": "1",
    "margin-left": "20px",
    "align-items": "center"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-weight": "bold",
    "color": "red",
    "margin-right": "10px"
  }
}, " 未审核 ", -1));
const _hoisted_8 = {
  key: 1,
  style: {
    "display": "flex",
    "flex": "1",
    "margin-left": "20px",
    "align-items": "center"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-weight": "bold",
    "color": "#208800"
  }
}, "已审核", -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 2,
  style: {
    "display": "flex",
    "flex": "1",
    "margin-left": "20px",
    "align-items": "center"
  }
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-weight": "bold",
    "color": "red"
  }
}, "拒绝", -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  key: 3,
  style: {
    "display": "flex",
    "flex": "1",
    "margin-left": "20px",
    "align-items": "center"
  }
};
const _hoisted_15 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_16 = {
  class: "main"
};
const _hoisted_17 = {
  class: "main_left"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "没有照片")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "加载错误")], -1));
const _hoisted_20 = {
  class: "main_left"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "没有照片")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "10px"
  }
}, null, -1));
const _hoisted_23 = {
  key: 0,
  class: "tab1Box"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 1,
  style: {
    "height": "10px"
  }
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  class: "main_right"
};
const _hoisted_28 = {
  class: "tab1Box"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  key: 1
};
const _hoisted_31 = {
  class: "tab2Box"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  class: "tab3Box"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "tab4Box"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  class: "tab5Box"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  class: "tab6Box"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "msgBox"
};
const _hoisted_42 = {
  class: "msg"
};
const _hoisted_43 = {
  class: "msg"
};
const _hoisted_44 = {
  class: "msg"
};
const _hoisted_45 = {
  class: "msg"
};
const _hoisted_46 = {
  class: "msg"
};
const _hoisted_47 = {
  class: "msg"
};
const _hoisted_48 = {
  class: "msg"
};
const _hoisted_49 = {
  class: "msg"
};
const _hoisted_50 = {
  class: "msg"
};
const _hoisted_51 = {
  key: 2,
  class: "store-info-box"
};
const _hoisted_52 = {
  class: "type2"
};
const _hoisted_53 = {
  style: {
    "font-size": "14px",
    "height": "28px",
    "width": "100%",
    "background-color": "#e7e7e7",
    "line-height": "28px",
    "margin-bottom": "10px"
  }
};
const _hoisted_54 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_55 = {
  class: "v-box",
  style: {
    "display": "flex",
    "margin-bottom": "10px"
  }
};
const _hoisted_56 = {
  style: {
    "margin-right": "10px",
    "max-width": "352px",
    "min-width": "352px"
  }
};
const _hoisted_57 = {
  class: "location-info-table"
};
const _hoisted_58 = {
  style: {
    "margin-right": "10px",
    "min-width": "150px",
    "max-width": "150px",
    "overflow": "hidden"
  }
};
const _hoisted_59 = {
  style: {
    "margin-right": "10px",
    "min-width": "150px",
    "max-width": "150px",
    "overflow": "hidden"
  }
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1));
const _hoisted_61 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_62 = {
  key: 0,
  class: "tab1Box"
};
const _hoisted_63 = ["onClick"];
const _hoisted_64 = {
  key: 1,
  style: {
    "height": "10px"
  }
};
const _hoisted_65 = {
  style: {
    "display": "flex",
    "overflow-x": "auto",
    "flex": "1"
  }
};
const _hoisted_66 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "start",
    "margin-right": "20px"
  }
};
const _hoisted_67 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "width": "130px",
    "height": "130px",
    "justify-content": "center"
  }
};
const _hoisted_68 = {
  class: "logo-upload-icon-box"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo-upload-icon-text"
}, "添加照片", -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "0px 20px"
  }
}, "加载中")], -1));
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "0px 20px"
  }
}, "加载错误")], -1));
const _hoisted_72 = {
  style: {
    "display": "flex",
    "margin-top": "15px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_image = _resolveComponent("el-image");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_el_upload = _resolveComponent("el-upload");
  return $setup.storeLocationData.data && $setup.storeLocationData.data.storeFloors ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString($setup.storeLocationData.data.storeName), 1), _createVNode(_component_svg_icon, {
    iconName: "picture",
    iconColor: '#030303',
    iconSize: "23px",
    onClick: _cache[0] || (_cache[0] = $event => $setup.storeLocationData.showType = 0),
    style: {
      "cursor": "pointer",
      "margin-left": "10px"
    }
  }), _createVNode(_component_svg_icon, {
    iconName: "location_sort",
    iconColor: '#030303',
    iconSize: "16px",
    onClick: _cache[1] || (_cache[1] = $event => $setup.storeLocationData.showType = 1),
    style: {
      "cursor": "pointer",
      "margin-left": "10px"
    }
  }), $setup.storeLocationData.showType == 1 && $setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' && $setup.storeLocationData.data.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "button-default",
    color: "black",
    style: {
      "width": "100px",
      "margin-left": "10px"
    },
    onClick: _cache[2] || (_cache[2] = $event => $setup.approvedUploadedAll())
  }, {
    default: _withCtx(() => [_createTextVNode(" 一键审核 ")]),
    _: 1
  })) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($setup.getInfoName()), 1), $setup.currentUploaded.uploadedInfo != null && $setup.currentUploaded.uploadedInfo.length > 0 && $setup.currentUploaded.uploadedInfo[$setup.currentUploaded.index].activityInstallationUploadStatusId == 1 && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, $setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.currentUploaded.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "button-default",
    color: "black",
    style: {
      "width": "100px"
    },
    onClick: _cache[3] || (_cache[3] = $event => $setup.approvedUploaded($setup.currentUploaded.uploadedInfo[$setup.currentUploaded.index]))
  }, {
    default: _withCtx(() => [_createTextVNode(" 审核通过 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.currentUploaded.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    class: "button-default",
    color: "black",
    style: {
      "width": "100px"
    },
    onClick: _cache[4] || (_cache[4] = $event => $setup.nullifiedUploaded($setup.currentUploaded.uploadedInfo[$setup.currentUploaded.index]))
  }, {
    default: _withCtx(() => [_createTextVNode(" 拒绝 ")]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.currentUploaded.uploadedInfo != null && $setup.currentUploaded.uploadedInfo.length > 0 && $setup.currentUploaded.uploadedInfo[$setup.currentUploaded.index].activityInstallationUploadStatusId == 2 && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)) : _createCommentVNode("", true), $setup.currentUploaded.uploadedInfo != null && $setup.currentUploaded.uploadedInfo.length > 0 && $setup.currentUploaded.uploadedInfo[$setup.currentUploaded.index].activityInstallationUploadStatusId == 3 && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)) : _createCommentVNode("", true), $setup.currentUploaded.uploadedInfo != null && $setup.currentUploaded.uploadedInfo.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($setup.currentUploaded.uploadedInfo[$setup.currentUploaded.index].activityName), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_image, {
    fit: "contain",
    style: {
      "height": "510px",
      "width": "100%",
      "background-color": "#f5f7fa"
    },
    src: $setup.storeLocationData.data.headerPhoto
  }, {
    placeholder: _withCtx(() => [_hoisted_18]),
    error: _withCtx(() => [_hoisted_19]),
    _: 1
  }, 8, ["src"])], 512), [[_vShow, $setup.headerSelect == true]]), _withDirectives(_createElementVNode("div", _hoisted_20, [_createVNode(_component_swiper, {
    ref: "uploadedSlide",
    centeredSlides: true,
    modules: [$setup.Thumbs, $setup.Navigation],
    navigation: "",
    thumbs: {
      swiper: $setup.thumbsSwiper
    },
    style: {
      "height": "510px"
    },
    onSwiper: $setup.onSwiper,
    onSlideChange: $setup.onSlideChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentUploaded.uploadedInfo, (x, index) => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: index,
        style: {
          "display": "flex",
          "justify-content": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          src: x.url,
          alt: "",
          fit: "contain",
          style: {
            "height": "510px",
            "width": "100%",
            "background-color": "#f5f7fa"
          },
          class: "swiper-lazy"
        }, {
          error: _withCtx(() => [_hoisted_21]),
          _: 2
        }, 1032, ["src"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "thumbs", "onSwiper", "onSlideChange"]), _hoisted_22, $setup.currentUploaded.activityVendors && $setup.activityId ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentUploaded.activityVendors, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      style: {
        "display": "flex",
        "align-items": "center"
      },
      class: _normalizeClass({
        tab1Select: index === $setup.storeLocationData.vendorTabIndex && $setup.headerSelect == false,
        tab1: true
      }),
      onClick: $event => {
        $setup.storeLocationData.vendorTabIndex = index;
        $setup.vendorTabChange(index, data.vendorId);
      },
      key: index
    }, [_createElementVNode("div", null, _toDisplayString(data.vendorName), 1), data.isEmpty && index !== $setup.storeLocationData.vendorTabIndex ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      color: "blue",
      iconName: "Tips",
      iconSize: "16px"
    })) : _createCommentVNode("", true)], 10, _hoisted_24);
  }), 128))])) : _createCommentVNode("", true), $setup.currentUploaded.activityVendors && $setup.activityId ? (_openBlock(), _createElementBlock("div", _hoisted_25)) : _createCommentVNode("", true), _createVNode(_component_swiper, {
    modules: [$setup.Thumbs],
    "watch-slides-progress": "",
    onSwiper: $setup.setThumbsSwiper,
    "space-between": 10,
    slidesPerView: 4,
    style: {
      "height": "122px"
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentUploaded.uploadedInfo, (x, index) => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: x.url,
          alt: "",
          style: {
            "background": "#f5f7fa",
            "height": "122px",
            "width": "154px",
            "object-fit": "cover"
          }
        }, null, 8, _hoisted_26)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "onSwiper"])], 512), [[_vShow, $setup.headerSelect == false]]), _createElementVNode("div", _hoisted_27, [$setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' && $setup.storeLocationData.data.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "button-default baoxiu",
    color: "black",
    style: {
      "width": "100px"
    },
    onClick: _cache[5] || (_cache[5] = $event => $setup.approvedUploadedAll())
  }, {
    default: _withCtx(() => [_createTextVNode(" 一键审核 ")]),
    _: 1
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.headerTabClick && $setup.headerTabClick(...args)),
    class: _normalizeClass([{
      tab1Select: $setup.headerSelect
    }, "tab1"])
  }, " 店铺信息 ", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.data.storeFloors, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        tab1Select: index === $setup.storeLocationData.tab1index && $setup.headerSelect == false,
        tab1: true
      }),
      onClick: $event => {
        $setup.storeLocationData.tab1index = index;
        $setup.resetIndex(1);
      },
      key: index
    }, _toDisplayString(data.locationName), 11, _hoisted_29);
  }), 128))]), $setup.headerSelect == false ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.data.storeFloors[$setup.storeLocationData.tab1index].locations, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        tab2Select: index === $setup.storeLocationData.tab2index,
        tab2: true
      }),
      onClick: $event => {
        $setup.storeLocationData.tab2index = index;
        $setup.resetIndex(2);
      },
      key: index
    }, _toDisplayString(data.locationName), 11, _hoisted_32);
  }), 128))]), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.data.storeFloors[$setup.storeLocationData.tab1index].locations[$setup.storeLocationData.tab2index].locations, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        tab3Select: index === $setup.storeLocationData.tab3index,
        tab3: true
      }),
      onClick: $event => {
        $setup.storeLocationData.tab3index = index;
        $setup.resetIndex(3);
      },
      key: index
    }, _toDisplayString(data.locationName), 11, _hoisted_34);
  }), 128))]), _createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.data.storeFloors[$setup.storeLocationData.tab1index].locations[$setup.storeLocationData.tab2index].locations[$setup.storeLocationData.tab3index].locations, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        tab4Select: index === $setup.storeLocationData.tab4index,
        tab4: true
      }),
      onClick: $event => {
        $setup.storeLocationData.tab4index = index;
        $setup.resetIndex(4);
      },
      key: index
    }, _toDisplayString(data.locationName), 11, _hoisted_36);
  }), 128))]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.data.storeFloors[$setup.storeLocationData.tab1index].locations[$setup.storeLocationData.tab2index].locations[$setup.storeLocationData.tab3index].locations[$setup.storeLocationData.tab4index].locations, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        tab5Select: index === $setup.storeLocationData.tab5index,
        tab5: true
      }),
      onClick: $event => {
        $setup.storeLocationData.tab5index = index;
        $setup.resetIndex(5);
      },
      key: index
    }, _toDisplayString(data.locationName), 11, _hoisted_38);
  }), 128))]), _createElementVNode("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.data.storeFloors[$setup.storeLocationData.tab1index].locations[$setup.storeLocationData.tab2index].locations[$setup.storeLocationData.tab3index].locations[$setup.storeLocationData.tab4index].locations[$setup.storeLocationData.tab5index].locations, (data, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        tab6Select: index === $setup.storeLocationData.tab6index,
        tab6: true
      }),
      onClick: $event => {
        $setup.storeLocationData.tab6index = index;
        $setup.resetIndex(6);
      },
      key: index
    }, _toDisplayString(data.locationName ? data.locationName : $setup.storeLocationData.data.storeFloors[$setup.storeLocationData.tab1index].locations[$setup.storeLocationData.tab2index].locations[$setup.storeLocationData.tab3index].locations[$setup.storeLocationData.tab4index].locations[$setup.storeLocationData.tab5index].locationName), 11, _hoisted_40);
  }), 128))]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createTextVNode(" 宽： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().wdith), 1)]), _createElementVNode("div", _hoisted_43, [_createTextVNode(" 高： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().height), 1)]), _createElementVNode("div", _hoisted_44, [_createTextVNode(" 性别： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().gender), 1)]), _createElementVNode("div", _hoisted_45, [_createTextVNode(" ICE： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().ice), 1)]), _createElementVNode("div", _hoisted_46, [_createTextVNode(" 材质： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().materialAndCraft), 1)]), _createElementVNode("div", _hoisted_47, [_createTextVNode(" 数量： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().quantity), 1)]), _createElementVNode("div", _hoisted_48, [_createTextVNode(" 尺寸： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().sizeDescription), 1)]), _createElementVNode("div", _hoisted_49, [_createTextVNode(" 支持类型： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().supportType), 1)]), _createElementVNode("div", _hoisted_50, [_createTextVNode(" 位置描述： "), _createElementVNode("span", null, _toDisplayString($setup.getInfo().locationDescription), 1)]), $setup.permission.havePermission('店铺管理', '报修') ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "button-default repair",
    color: "#000",
    onClick: _cache[7] || (_cache[7] = $event => $setup.goRepair($setup.getInfo()))
  }, {
    default: _withCtx(() => [_createTextVNode("报修")]),
    _: 1
  })) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_51, [_createElementVNode("div", null, " 店铺名称:   " + _toDisplayString($setup.storeLocationData.data.storeName), 1), _createElementVNode("div", null, " 店铺编码:   " + _toDisplayString($setup.storeLocationData.data.storeCode), 1), _createElementVNode("div", null, " 店铺类型:   " + _toDisplayString($setup.storeLocationData.data.storeTypeNameZh), 1), _createElementVNode("div", null, " 省份:   " + _toDisplayString($setup.storeLocationData.data.province), 1), _createElementVNode("div", null, "城市:   " + _toDisplayString($setup.storeLocationData.data.city), 1), _createElementVNode("div", null, " 地址:   " + _toDisplayString($setup.storeLocationData.data.storeAddress), 1), _createElementVNode("div", null, " 联系人:   " + _toDisplayString($setup.storeLocationData.data.contactName), 1), _createElementVNode("div", null, " 联系方式:   " + _toDisplayString($setup.storeLocationData.data.contactMobile), 1), _createElementVNode("div", null, " 邮箱:   " + _toDisplayString($setup.storeLocationData.data.contactEmail), 1)]))])])], 512), [[_vShow, $setup.storeLocationData.showType === 0]]), _withDirectives(_createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeLocationData.locations, (location, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(location.locationLabel), 1)]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("table", _hoisted_57, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_58, " 位置描述：" + _toDisplayString(location.locationDescription), 1), _createElementVNode("td", null, "支持类型：" + _toDisplayString(location.supportType), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_59, " 尺寸：" + _toDisplayString(location.sizeDescription), 1), _createElementVNode("td", null, "材质：" + _toDisplayString(location.materialAndCraft), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, "ICE：" + _toDisplayString(location.ice), 1), _createElementVNode("td", null, "数量：" + _toDisplayString(location.quantity), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, "性别：" + _toDisplayString(location.gender), 1), _createElementVNode("td", null, "宽：" + _toDisplayString(location.width), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, "高：" + _toDisplayString(location.height), 1), _hoisted_60])])]), _createElementVNode("div", _hoisted_61, [$setup.activityId ? (_openBlock(), _createElementBlock("div", _hoisted_62, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location.activityVendors, (data, index) => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "display": "flex",
          "align-items": "center"
        },
        class: _normalizeClass({
          tab1Select: index === location.vendorTabIndex,
          tab1: true
        }),
        onClick: $event => {
          location.vendorTabIndex = index;
          $setup.vendorTabBarChange(location, index);
        },
        key: index
      }, [_createElementVNode("div", null, _toDisplayString(data.vendorName), 1), data.isEmpty && index !== location.vendorTabIndex ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        color: "blue",
        iconName: "Tips",
        iconSize: "16px"
      })) : _createCommentVNode("", true)], 10, _hoisted_63);
    }), 128))])) : _createCommentVNode("", true), $setup.activityId ? (_openBlock(), _createElementBlock("div", _hoisted_64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_65, [$setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' && location.installationStatusId == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_createVNode(_component_el_upload, {
      class: "logo-upload-box",
      drag: "",
      ref_for: true,
      ref: "uploadActivityPhoto",
      accept: "image/png, image/jpeg, image/gif, image/jpg",
      "show-file-list": false,
      action: $setup.uploadActivityPhotoData.signatureData.host,
      "before-upload": file => {
        return $setup.handleActivityPhotoBeforeUpload(file, location.storeLocationId);
      },
      "on-success": $setup.handleActivityPhotoOnSuccess,
      data: $setup.uploadActivityPhotoData.data,
      "on-exceed": $setup.handleActivityPhotoExceed,
      "file-list": $setup.uploadActivityPhotoData.fileList,
      multiple: ""
    }, {
      default: _withCtx(() => [$setup.uploadActivityPhotoData.file.url === null ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createVNode(_component_svg_icon, {
        iconName: "tk_plus",
        iconColor: '#d3d3d3',
        iconSize: "32px"
      })]), _hoisted_69])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["action", "before-upload", "on-success", "data", "on-exceed", "file-list"])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location.uploaded, (x, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: {
          "display": "flex",
          "flex-direction": "column",
          "align-items": "center",
          "margin-right": "20px",
          "justify-content": "start",
          "flex-shrink": "0"
        }
      }, [_createTextVNode(_toDisplayString(x.activityName) + " ", 1), _createVNode(_component_el_image, {
        fit: "cover",
        src: x.url,
        alt: "",
        "preview-teleported": "",
        "preview-src-list": [x.url],
        style: {
          "height": "130px",
          "min-height": "130px",
          "width": "130px",
          "background-color": "#f5f7fa",
          "flex-shrink": "0",
          "white-space": "nowrap"
        }
      }, {
        placeholder: _withCtx(() => [_hoisted_70]),
        error: _withCtx(() => [_hoisted_71]),
        _: 2
      }, 1032, ["src", "preview-src-list"]), _createElementVNode("div", _hoisted_72, [x.activityInstallationUploadStatusId == 1 && $setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' && location.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: $event => $setup.approvedUploaded(x),
        class: "button-default",
        color: "black",
        style: {
          "width": "60px",
          "margin-bottom": "5px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 审核通过 ")]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true), x.activityInstallationUploadStatusId == 1 && $setup.permission.havePermission('店铺管理', '活动照片审核') && $setup.storeLocationData.installationId != null && $setup.storeLocationData.installationId != '' && location.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        onClick: $event => $setup.nullifiedUploaded(x),
        class: "button-default",
        color: "black",
        style: {
          "width": "60px",
          "margin-bottom": "5px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 拒绝 ")]),
        _: 2
      }, 1032, ["onClick"])) : _createCommentVNode("", true)])]);
    }), 128))])])])]);
  }), 128))], 512), [[_vShow, $setup.storeLocationData.showType === 1]])])) : _createCommentVNode("", true);
}